import store from "../store";

function toRadians (angle) {
    return angle * (Math.PI / 180);
}

// export function getBounds(event, index) {
export function getBounds(event, index, rotateAngle = 0) {
    const angle = toRadians(rotateAngle)
    const captions = store.getState().slideReducer.captions;
    const viewType = store.getState().menuReducer.viewType;
    const widthProperty = viewType === 'desktop' ? 'width' : 'mobileWidth';
    const heigthProperty = viewType === 'desktop' ? 'height' : 'mobileHeight';
    const borderWidthProperty = viewType === 'desktop' ? 'borderWidth' : 'mobileBorderWidth';
    let bounds = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
    }
    const diff = 0;

    if (viewType === 'mobile') {
    // if (viewType === 'mobile' && captions[index].boxId !== '') {
    // если капча вложена в бокс, то в мобильном виде её перемещение ограничены этим родителем
        return 'parent'
    }
    const workspaceElement = document.getElementById('workspace')

    if (workspaceElement) {
        const caption = captions[index]
        if (caption) {
            const workspace = workspaceElement.getBoundingClientRect()
            const captionElement = workspaceElement.querySelector(`#caption-${index}`)
            if (captionElement) {
                // лучше получать размеры элемента напрямую из DOM
                const captionSizes = captionElement.getBoundingClientRect()
                bounds.right = workspace.width - captionSizes.width
                bounds.bottom = workspace.height - captionSizes.height
            } else {
                // если вдруг элемент не нашёлся, хотя такого быть не должно
                bounds.right = workspace.width - caption[widthProperty] - diff
                bounds.bottom = workspace.height - caption[heigthProperty] - diff
            }

            
            // switch (viewType) {
                //     case 'desktop':


            // // поворот текста
            // if (caption.type === 'text') {

            //     const captionElement = document.getElementById('caption-' + index)
            //     if (captionElement) {

            //         const captionWidth = parseInt(window.getComputedStyle(captionElement, null).getPropertyValue("width"));
            //         const captionHeight = parseInt(window.getComputedStyle(captionElement, null).getPropertyValue("height"));
            //         // console.log('captionElement.getBoundingClientRect()',captionElement.getBoundingClientRect());
            //         // console.log('bounds before',bounds);
            //         if (rotateAngle !== 0) {
            //             bounds.right = workspace.width - captionWidth* Math.cos(angle)
            //             bounds.left = captionHeight * Math.sin(angle)
            //             bounds.bottom = workspace.height - captionElement.getBoundingClientRect().height
                        
            //         }
            //         // console.log('bounds after',bounds);
            //     }
            // }


            // если капча вложена в бокс
            if (caption.boxId != '') {
                const boxIndex = _.findIndex(captions, { id: caption.boxId })
                let boxInDom = document.getElementById(`caption-${boxIndex}`)
                if (boxInDom) {
                    boxInDom = boxInDom.getBoundingClientRect()

                    boxInDom.x -= workspace.x
                    boxInDom.y -= workspace.y
                    let boxZone = {
                        x1: boxInDom.x,
                        x2: boxInDom.x + boxInDom[widthProperty],
                        y1: boxInDom.y,
                        y2: boxInDom.y + boxInDom[heigthProperty],
                        index: caption.index,
                        id: caption.id,
                        borderWidth: caption[borderWidthProperty],
                    }

                    bounds.left = -boxZone.x1
                    bounds.top = -boxZone.y1
                    bounds.right -= boxZone.x1
                    bounds.bottom -= boxZone.y1
                }
            }
            // break;

            //     case 'mobile':
            //         bounds.right = workspace.width - caption.mobileWidth - diff
            //         bounds.bottom = workspace.height - caption.mobileHeight
            //         if (caption.boxId != '') {
            //             const boxIndex = _.findIndex(captions, { id: caption.boxId })
            //             const box = captions[boxIndex]
            //             return `#caption-${box.index}`
            //         }
            //         break;
            // }
            // console.log('bounds',bounds);
            return bounds
        }
    } else {
        return false
    }
}


export function alignToRulers(draggedCaption, rulersArray, x, y) {
    // debugger
    const viewType = store.getState().menuReducer.viewType
    const widthProperty = viewType === 'desktop' ? 'width' : 'mobileWidth';
    const heightProperty = viewType === 'desktop' ? 'height' : 'mobileHeight';

    rulersArray.map((ruler) => {
        switch (ruler.type) {
            case 'horizontal':
                if (Math.abs(x - ruler.position.x) < 10) {
                    x = ruler.position.x + 2
                } else if (Math.abs(x + draggedCaption[widthProperty] - ruler.position.x) < 10) {
                    x = ruler.position.x - draggedCaption[widthProperty] - 2
                }
                break;

            case 'vertical':
                if (Math.abs(y - ruler.position.y) < 10) {
                    y = ruler.position.y + 2
                } else if (Math.abs(y + draggedCaption[heightProperty] - ruler.position.y) < 10) {
                    y = ruler.position.y - draggedCaption[heightProperty] - 2
                }
                break;
        }
    })

    return { x, y }
}
